import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import ComponentTable from '../../../Components/Table/Index';
import { Column } from '../../../Components/Table/Types';
import * as Icon from '@mui/icons-material/';
import { useNavigate } from 'react-router-dom';
import { CentroCustoAtualizar, CentroCustoCadastrar } from '../../../../routes/RoutesNames';
import { useSelector } from 'react-redux';
import CentroCustoController from '../../../../controllers/CentroCustoController';
import { Button } from '../../../../shared/components/button/Button';
import { toast } from 'react-toastify';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { ButtonMenu } from '../../../../shared/components/ButtonMenu'
import FormBuilder from '../../../../shared/components/FormBuilder';

interface Row {
  BtnEditar?: JSX.Element;
  BtnExcluir?: JSX.Element;
  cc_id: number;
  cc_descricao: string;
}

export default function CentroCusto() {
  const userId = useSelector((state: any) => state.Authentication.userId);
  const navigate = useNavigate();
  const tableColumns: Column[] = [
    { id: 'Id', label: 'Id', minWidth: 0 },
    { id: 'Descricao', label: 'Descrição', minWidth: 0 },
    { id: 'BtnMenu', label: '', width: 60, minWidth: 0, align: 'right' }
  ];
  const fields = [
    { name: 'cc_id', type: 'text', label: 'Código' },
    { name: 'Descricao', type: 'text', label: 'Descrição' },
    { type: 'submit', icon: (<Icon.Search style={{ fontSize: '28px' }} />) },
  ]

  const [tableRows, setTableRows] = useState<Row[]>([]);
  
  const initialValues = {
    cc_id: null,
    Descricao: '',
  };

  const handleNavigation = async (): Promise<void> => {
    navigate(CentroCustoCadastrar);
  };

  const handleEditItem = (item: Row, duploClick = false, duploClickId = 0) => {
    if (duploClick) {
      navigate(CentroCustoAtualizar.replace(':id', duploClickId.toString()), { state: { duploClick: true } });
    }
    else {
    navigate(CentroCustoAtualizar.replace(':id', item.cc_id.toString()));
    }
  };

  const handleSubmit = async (values: any) => {
    const DataRows: any = [];
    const Response = await CentroCustoController.Listar(values);

    if (Response.StatusCode === 200 && Response?.Data?.length > 0) {
      Response.Data.map((item: Row) => {
        DataRows.push({
          Id: item.cc_id,
          Descricao: item.cc_descricao,
          BtnMenu: (
            <ButtonMenu
              items={[
                { onClick: () => handleEditItem(item), menu: "Editar" },
                { onClick: () => handleDeleteItem(item.cc_id), menu: "Excluir", confirmar: `Excluir o centro de custo "${item.cc_descricao ?? ''}"? Esta ação não pode ser desfeita.` },
              ]}
            />
          ),
        });

        setTableRows(DataRows);
      });
    } else if (Response.StatusCode === 204 && Response?.Data?.length === 0) {
      toast('Não há registros cadastrados.', {
        type: 'warning',
      });
    } else {
      toast(Response?.Data, {
        type: 'error',
      });
    }
  };

  const handleDeleteItem = async (cc_id: number) => {
    const request: any = { UsuId: userId, CentroCustoId: cc_id };
    const response = await CentroCustoController.Excluir(request);

    if (response.StatusCode === 204) {
      toast('Centro de Custo excluído com sucesso!', {
        type: 'success',
      });
      handleSubmit(initialValues);
    } else {
      toast('Erro ao excluir Centro de Custo!', {
        type: 'error',
      });
    }
  };

  useEffect(() => {
    handleSubmit(initialValues)
  }, []);

  return (
    <Box>
      <HeaderComponent text={'CENTRO DE CUSTOS'}
        ButtonRight={
          <Button
            className={''}
            variant='success'
            onClick={handleNavigation}
            iconStart={<Icon.Add />}
            title={'Incluir'}
          />
        }
      />
      <FormBuilder fields={fields} initialValues={initialValues} onSubmit={handleSubmit} />
      <ComponentTable columns={tableColumns} rows={tableRows} 
         onRowDoubleClick={(row) => {handleEditItem(row, true, row.Id);}} />
    </Box>
  );
}
